"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toTime = void 0;
const divide = (n, divider) => {
    return {
        q: Math.floor(n / divider),
        r: Math.round(n % divider),
    };
};
const padZero = (n) => {
    if (n < 10) {
        return `0${n}`;
    }
    return `${n}`;
};
exports.toTime = (seconds) => {
    if (seconds > 60 * 60) {
        const h = divide(seconds, 60 * 60);
        const m = divide(h.r, 60);
        return `${padZero(h.q)}:${padZero(m.q)}:${padZero(m.r)}`;
    }
    if (seconds > 60) {
        const m = divide(seconds, 60);
        return `${padZero(m.q)}:${padZero(m.r)}`;
    }
    return `${padZero(0)}:${padZero(Math.round(seconds))}`;
};
//# sourceMappingURL=toTime.js.map